import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabservicekondhapurhyderabad() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Kondapur Hyderabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Kondapur Hyderabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Kondapur Hyderabad, catering to the transportation needs of IT parks, corporate offices, and business centers in the area. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Kondapur Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is Hyderabad’s most iconic landmark, built in 1591 by Sultan Muhammad Quli Qutb Shah. This grand square-shaped monument features four towering minarets and intricate Islamic architecture. Surrounded by bustling bazaars, street food vendors, and shops selling pearls, bangles, and traditional crafts, Charminar is a cultural and historical hub, attracting tourists from across India and the world."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic fortress located on the outskirts of Hyderabad, known for its massive walls, impressive gateways, and acoustic marvels. Once the capital of the Qutb Shahi dynasty, it offers panoramic views of the city and nearby hills. The evening light and sound show narrates the fort’s rich history, making it a favorite destination for history enthusiasts and photographers."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a large man-made lake in the heart of Hyderabad, famous for the gigantic Buddha statue standing on Gibraltar Rock in the middle of the water. The lake is popular for boating, evening walks, and lakeside leisure. Surrounded by parks, eateries, and promenades, it serves as a serene escape and recreational spot for locals and tourists."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest museums, housing an extensive collection of art, sculptures, manuscripts, and artifacts from India and around the world. Visitors can explore centuries of history and culture through exhibits such as Mughal miniatures, European paintings, and decorative arts. The museum provides an immersive educational experience for art and history enthusiasts."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is one of the world’s largest film studio complexes and a popular entertainment destination near Hyderabad. Spread across thousands of acres, it features film sets, amusement rides, gardens, and live shows. Visitors can enjoy guided tours, interactive experiences, and cultural performances, making it a top choice for family outings and film enthusiasts."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace is a stunning 18th-century palace that once served as the seat of the Nizams of Hyderabad. The complex features grand halls, intricate interiors, beautiful courtyards, and royal artifacts. Visitors can explore the opulent architecture and learn about the history and lifestyle of the Nizams, making it a cultural and historical gem of the city."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a magnificent white marble temple dedicated to Lord Venkateswara, located on a hill overlooking Hyderabad. The temple offers panoramic views of the city and the lake below. Visitors can admire the detailed carvings, serene surroundings, and participate in spiritual rituals, making it a peaceful retreat in the heart of the city."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is Hyderabad’s famous shopping street, known for its vibrant bangles, jewelry, pearls, textiles, and handicrafts. The bustling markets and colorful storefronts create an authentic local experience. It is a must-visit for tourists looking to shop, explore, and enjoy the vibrant culture of the old city."
  },
  {
    "title": "Necklace Road",
    "description": "Necklace Road is a scenic boulevard along Hussain Sagar Lake, popular for evening walks, recreational activities, and lakeside dining. It features landscaped gardens, jogging tracks, and food stalls. The area is ideal for leisure, family outings, and enjoying the illuminated view of the Buddha statue on the lake."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs are the royal necropolis of the Qutb Shahi dynasty, located near Golconda Fort. The complex features grand domed tombs, landscaped gardens, and intricate stonework. Visitors can explore the historical architecture, learn about the dynasty’s legacy, and enjoy peaceful walks amidst the ancient structures."
  }
],


"services": [
{
"name": "Kondapur IT Cab",
"description": "Kondapur IT Cab provides dedicated corporate transportation services for employees, executives, and visitors commuting to IT offices and tech parks in Kondapur. Featuring a fleet of sedans, SUVs, and shuttle vans, the service ensures punctual pickups, flexible routing, multi-shift support, GPS-enabled tracking, and professional chauffeurs. Designed for high-density IT hubs, it delivers safe, reliable, and hassle-free daily commuting across Kondapur."
},
{
"name": "Business Cab Kondapur",
"description": "Business Cab Kondapur offers premium corporate travel solutions for meetings, client visits, airport transfers, and inter-office mobility. With modern vehicles and experienced chauffeurs trained in corporate protocols, it ensures comfort, punctuality, and a seamless travel experience for business professionals across Kondapur."
},
{
"name": "Employee Shuttle Kondapur",
"description": "Employee Shuttle Kondapur delivers high-capacity shuttle services for companies with large workforce movement. Featuring AC minibuses, optimized routes, automated attendance integration, and real-time tracking, it supports peak-hour travel and multi-shift operations, ensuring safe and organized employee transportation throughout Kondapur."
},
{
"name": "Office Pickup Drop Kondapur",
"description": "Office Pickup Drop Kondapur provides structured daily commute services with pre-planned routes, professional drivers, and GPS-enabled monitoring. Ideal for corporate offices and IT parks, it ensures employees reach their workplace safely, on time, and with consistent reliability across all Kondapur business zones."
},
{
"name": "Monthly Cab Kondapur",
"description": "Monthly Cab Kondapur offers contract-based employee and executive transportation solutions for consistent daily commuting. The service includes dedicated vehicles, trained drivers, vehicle maintenance, GPS monitoring, and 24/7 support, ensuring cost-effective and uninterrupted mobility for organizations in Kondapur."
},
{
"name": "Best Corporate Cab Kondapur",
"description": "Best Corporate Cab Kondapur provides premium-grade corporate transportation with top-quality vehicles, expert chauffeurs, advanced safety standards, and reliable operations. Suitable for executives, managers, and visiting clients, it ensures a smooth, comfortable, and professional travel experience across Kondapur IT and corporate hubs."
},
{
"name": "Affordable Cab Kondapur",
"description": "Affordable Cab Kondapur offers cost-effective yet reliable corporate transportation for startups, SMEs, and mid-sized companies. With optimized routes, clean vehicles, professional drivers, and transparent pricing, it ensures economical daily commuting without compromising safety or comfort."
},
{
"name": "Outstation Cab Kondapur",
"description": "Outstation Cab Kondapur provides long-distance corporate travel solutions for client visits, business trips, intercity travel, and executive tours. Equipped with comfortable sedans and SUVs, trained chauffeurs, interstate permits, and real-time tracking, it ensures safe and professionally managed outstation mobility for companies."
},
{
"name": "Sedan Cab Kondapur",
"description": "Sedan Cab Kondapur offers executive sedans ideal for managerial commute, airport transfers, client visits, and daily premium office travel. Featuring well-maintained interiors, professional drivers, and smooth ride quality, it provides a comfortable and refined travel experience for corporate employees."
},
{
"name": "SUV Cab Kondapur",
"description": "SUV Cab Kondapur provides spacious and high-comfort SUVs suitable for senior executive travel, team movement, outstation trips, and long-distance drives. With advanced safety standards, trained chauffeurs, and GPS tracking, it delivers a premium travel experience tailored to corporate mobility needs."
},
{
"name": "Corporate Fleet Kondapur",
"description": "Corporate Fleet Kondapur offers end-to-end fleet management and outsourcing solutions for businesses requiring fully managed employee transportation. With sedans, SUVs, shuttles, and staff cabs, it includes driver management, vehicle maintenance, compliance tracking, and route optimization across Kondapur corporate zones."
},
{
"name": "Staff Transport Kondapur",
"description": "Staff Transport Kondapur provides structured daily transport for employees with fixed and flexible routes, real-time tracking, trained drivers, and shift-based operations. Ideal for companies with large or mid-sized workforces, it ensures safe, punctual, and organized employee commute across Kondapur."
},
{
"name": "Company Cab Kondapur",
"description": "Company Cab Kondapur offers complete corporate cab services including employee and executive transport, visitor movement, and on-demand mobility. With a monitored fleet, skilled drivers, maintenance support, and compliance adherence, it ensures seamless and efficient corporate travel for organizations in Kondapur."
},
{
"name": "IT Park Shuttle Kondapur",
"description": "IT Park Shuttle Kondapur delivers high-volume shuttle services for IT park employees and corporate campuses. Featuring optimized multi-route planning, automated attendance integration, GPS tracking, and safety protocols, it ensures efficient and coordinated employee transportation within Kondapur’s IT zones."
},
{
"name": "Employee Mobility Kondapur",
"description": "Employee Mobility Kondapur provides comprehensive workforce mobility solutions including shuttles, point-to-point cabs, monthly rentals, and on-demand transport. Focused on safety, reliability, route optimization, and tech-driven coordination, it ensures smooth and scalable employee commuting across Kondapur’s corporate and IT hubs."
}
],

"tableData": [
["Kondapur IT Cab", "Business Cab Kondapur"],
["Employee Shuttle Kondapur", "Office Pickup Drop Kondapur"],
["Monthly Cab Kondapur", "Best Corporate Cab Kondapur"],
["Affordable Cab Kondapur", "Outstation Cab Kondapur"],
["Sedan Cab Kondapur", "SUV Cab Kondapur"],
["Corporate Fleet Kondapur", "Staff Transport Kondapur"],
["Company Cab Kondapur", "IT Park Shuttle Kondapur"],
["Employee Mobility Kondapur", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Kondapur Hyderabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Kondapur Hyderabad, ensuring smooth and efficient transportation for employees and business executives across the IT and business hubs."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee punctual pickups and drop-offs across Kondapur’s IT parks, offices, and commercial areas, helping employees reach their workplaces and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our skilled chauffeurs deliver safe, courteous, and disciplined travel, ensuring a secure and comfortable commute for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Kondapur."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible and tailored cab rental plans designed to meet the commuting requirements of companies and employees in Kondapur Hyderabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team offers round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering safe, hygienic, and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking process and reliable coordination, making employee transport hassle-free."
  }
]
































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Kondapur, Hyderabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers dependable and professional corporate cab services for companies and IT offices in Kondapur, Hyderabad.',
  },
  {
    question: 'What types of corporate transportation services do you provide in Kondapur?',
    answer: 'We offer employee transportation, corporate pickups and drops, shuttle services, airport transfers, last-mile connectivity, and complete fleet management.',
  },
  {
    question: 'Do you support daily employee commute services in Kondapur?',
    answer: 'Yes, we provide structured daily commute solutions with optimized routes, timely pickups, and multi-shift operational support.',
  },
  {
    question: 'How can companies book corporate cab services in Kondapur?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Kondapur?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric vehicles based on company requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts for Kondapur offices?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with customized pricing and full fleet management.',
  },
  {
    question: 'Are your cabs equipped with GPS and safety systems?',
    answer: 'All vehicles include GPS tracking, real-time monitoring, regular sanitization, and professional trained chauffeurs for maximum safety.',
  },
  {
    question: 'Do you offer transportation solutions for night shifts and rotational shifts in Kondapur?',
    answer: 'Absolutely. We support night shifts, early morning shifts, weekend operations, and rotational employee schedules.',
  },
  {
    question: 'What payment modes do you accept for corporate cab services?',
    answer: 'We accept UPI, bank transfers, digital wallets, credit/debit cards, and also offer consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Venkata',
    feedback: 'Excellent corporate cab service in Kondapur. Consistent punctuality and clean, well-maintained vehicles.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Aashika Raman',
    feedback: 'Highly professional transportation partner. Our employees appreciate their timely service and courteous drivers.',
    rating: 5,
  },
];










































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Kondapur Hyderabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-kondapur.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited offers professional corporate cab services in Kondapur Hyderabad, including IT park shuttle service, business cabs, employee shuttle solutions, office pickup & drop, monthly cab rentals, corporate fleet support, and outstation cab services for companies in Kondapur.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-kondapur-hyderabad"
  }
};



  return (
    <div>

<Helmet>
  <title>Corporate Cab Service in Kondapur Hyderabad | IT Park & Employee Shuttle</title>

  <meta
    name="description"
    content="Reliable corporate cab service in Kondapur Hyderabad including IT park cab service, business cabs, employee shuttle, staff transport, office pickup & drop, monthly cab plans, and affordable outstation corporate cabs."
  />

  <meta
    name="keywords"
    content="Kondapur IT Cab, Business Cab Kondapur, Employee Shuttle Kondapur, Office Pickup Drop Kondapur, Monthly Cab Kondapur, Best Corporate Cab Kondapur, Affordable Cab Kondapur, Outstation Cab Kondapur, Sedan Cab Kondapur, SUV Cab Kondapur, Corporate Fleet Kondapur, Staff Transport Kondapur, Company Cab Kondapur, IT Park Shuttle Kondapur, Employee Mobility Kondapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabservicekondhapurhyderabad;